import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Iconify from "./iconify";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IconButtonAnimate } from "./animate";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import CalendarIcon from "src/assets/icons/CalendarIcon";
import { Box, Typography } from "@mui/material";
import { Translate } from "@mui/icons-material";
import { useLocales } from "src/locales";

ButtonDatePicker.propTypes = {
  date: PropTypes.instanceOf(Date),
  changeDate: PropTypes.func,
  isSmall: PropTypes.bool
};

export default function ButtonDatePicker({
  date,
  changeDate,
  isSmall = true,
  slotProps,
  ...other
}) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          slots={{ field: isSmall ? ButtonField : ButtonFieldLarge }}
          slotProps={{ field: { setOpen }, slotProps }}
          open={open}
          onOpen={() => handleClickOpen()}
          onClose={() => handleClose()}
          onChange={changeDate}
          value={dayjs(date)}
          {...other}
        />
      </LocalizationProvider>
    </React.Fragment>
  );
}

function ButtonField({ setOpen, id, disabled, InputProps: { ref } = {} }) {
  return (
    <IconButtonAnimate
      sx={{
        width: 40,
        height: 40,
        backgroundColor: (theme) => theme.palette.background.paper,
        '&:hover': {
          backgroundColor: (theme) => theme.palette.background.paper
        },
        borderRadius: "8px"
      }}
      id={id}
      disabled={disabled}
      disableRipple
      ref={ref}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <CalendarIcon />
    </IconButtonAnimate>
  );
}

function ButtonFieldLarge({ setOpen, id, disabled, InputProps: { ref } = {} }) {
  const {translate} = useLocales();
  return (
    <IconButtonAnimate
      sx={{
        width: 64,
        height: 80,
        backgroundColor: (theme) => theme.palette.grey[700],
        '&:hover': {
          backgroundColor: (theme) => theme.palette.background.paper
        },
        borderRadius: "8px"
      }}
      id={id}
      disabled={disabled}
      disableRipple
      ref={ref}
      onClick={() => setOpen?.((prev) => !prev)}
    >
      <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: 1}}>
        <CalendarIcon />
        <Typography variant="caption" color="white" sx={{fontSize: "10px", lineHeight: "10px"}}>{translate('tickets.other')}<br/>{translate('tickets.dates')}</Typography>
      </Box>

    </IconButtonAnimate>
  );
}

